import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {
    trainingOptions: [],
    reviewModeOptions: [],
    submitModeOptions: [],
}

const actions = {
    // 获取题库统计信息
    getManageInfo({dispatch},data) {
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:question:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/${data}/overview`,
                    }).then(data => {
                        resolve(data);
                    });
                }else {
                    resolve()
                }
            })
        })
    },

    // 获取题目管理列表
    getManageList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:question:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/${data.id}/question`,
                        params: data.form
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 题目详情
    getQuestionPreview({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/${data}`,
                data: { id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量导入题目校验
    importQuestionVerification({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/${data.id}/question/batch/inspection`,
                method: "post",
                data: data.file,
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量导入题目
    importQuestions({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/${data.id}/question/batch`,
                method: "post",
                data: JSON.stringify({questions: data.question}),
                headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 创建题目
    postManageQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/${data.id}/question`,
                method: "post",
                data: JSON.stringify(data)
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑题目
    putManageQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/${data.id}`,
                method: "put",
                data: JSON.stringify(data)
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除题目
    deleteManageQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/${data}`,
                method: "delete",
                // params: { id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量删除题目
    batchDeleteManageQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question`,
                method: "delete",
                data: { id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量设置难度
    batchSetDifficulty({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/difficulty`,
                method: "put",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 批量设置分数
    batchSetScore({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question/score`,
                method: "put",
                data: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}